<template>
  <div class="cw-whatsapp-broadcast">
    <iframe
      class="cw-whatsapp-iframe"
      :src="iframeUrl"
      frameborder="0"
      allow="clipboard-read; clipboard-write"
    />
  </div>
</template>

<script>
export default {
  name: 'WhatsappBroadcast',
  computed: {
    iframeUrl() {
      const accountId = this.$route?.params?.accountId;

      // Se por algum motivo não tiver accountId (rota fora do padrão), cai num fallback seguro
      const safeAccountId = Number.isFinite(Number(accountId)) ? Number(accountId) : 1;

      // Base do seu webapp (Flask)
      const base = 'https://router.convertia.lucassilabs.com';

      // Rota nova do seu Flask
      return `${base}`;
    },
  },
};
</script>

<style scoped>
.cw-whatsapp-broadcast {
  height: calc(100vh - 64px);
  width: 100%;
}

.cw-whatsapp-iframe {
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 12px;
}
</style>
